import { render, staticRenderFns } from "./HealthyFullView.vue?vue&type=template&id=585c282a&scoped=true&"
import script from "./HealthyFullView.vue?vue&type=script&lang=js&"
export * from "./HealthyFullView.vue?vue&type=script&lang=js&"
import style0 from "./HealthyFullView.vue?vue&type=style&index=0&id=585c282a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c282a",
  null
  
)

export default component.exports